import * as React from 'react';
export const sandboxSvg = React.forwardRef(function sandboxSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M5.282 1.152a1.767 1.767 0 0 1 1.436 0l4.391 1.952c.542.24.891.778.891 1.37v3.08a1.5 1.5 0 0 1-.855 1.354l-3.987 1.899a2 2 0 0 1-.86.194h-.596a2 2 0 0 1-.86-.194l-3.987-1.9A1.5 1.5 0 0 1 0 7.553V4.475c0-.593.35-1.13.89-1.37l4.392-1.953ZM10.6 5.536v2.017a.1.1 0 0 1-.057.09L6.7 9.473V7.437l3.9-1.9ZM6.5 2.588v1.59l1.91.868 1.727-.842L6.5 2.588Zm-1 1.59v-1.59L1.863 4.204l1.727.842 1.91-.868ZM6 6.221l-1.244-.606L6 5.049l1.244.566L6 6.22Zm-4.6-.685 3.9 1.901v2.036l-3.843-1.83a.1.1 0 0 1-.057-.09V5.536Z',
    }),
  );
});
sandboxSvg.defaultProps = {
  width: '12',
  height: '12',
  viewBox: '0 0 12 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var sandbox = {
  category: 'icon',
  colorable: true,
  name: 'sandbox',
  svg: sandboxSvg,
};
